(function () {

  "use strict";


  /* =========================================================
     CONFIG
     ========================================================= */

  const CONFIG = {

    /*
     * MediaPipe WASM
     */
    wasm:
      "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.21/wasm",


    /*
     * Hand Landmarker model
     */
    model:
      "https://storage.googleapis.com/mediapipe-models/hand_landmarker/hand_landmarker/float16/1/hand_landmarker.task",


    /*
     * Default finger used for auto placement.
     *
     * The customer can drag the ring to any
     * other finger afterwards.
     *
     * MediaPipe landmark pairs (MCP, PIP):
     *
     * thumb  = 2, 3
     * index  = 5, 6
     * middle = 9, 10
     * ring   = 13, 14
     * pinky  = 17, 18
     */
    defaultFinger: [13, 14],


    /*
     * Ring position along the finger segment.
     *
     * 0 = MCP / base knuckle
     * 1 = PIP joint
     */
    ringCenterAlongFinger: 0.62,


    /*
     * Ring visual size relative to
     * the finger segment length.
     */
    ringSizeMultiplier: 0.72,


    /*
     * Fallback ring width (fraction of photo
     * width) when no hand is detected.
     */
    fallbackRingWidth: 0.2,


    /*
     * Rotation adjustment in radians.
     *
     * 0
     * 90deg  = Math.PI / 2
     * -90deg = -Math.PI / 2
     */
    ringRotationOffset: 0,


    /*
     * Zoom limits (also used by the slider).
     */
    minScale: 0.3,

    maxScale: 3,


    /*
     * Back camera is NOT mirrored.
     */
    mirrorCamera: false,


    /*
     * Max captured photo size sent to
     * MediaPipe (keeps mobile fast).
     */
    maxCaptureSize: 1280

  };


  /* =========================================================
     DOM
     ========================================================= */

  let openButton;
  let modal;
  let closeButton;
  let overlay;

  let stage;
  let video;
  let canvas;
  let ctx;

  let hint;

  let cameraButton;
  let captureButton;
  let retakeButton;
  let cancelButton;

  let adjustPanel;
  let sizeSlider;
  let rotateSlider;
  let resetButton;

  let status;
  let loading;
  let loadingText;
  let stageMessage;


  /* =========================================================
     STATE
     ========================================================= */

  let handLandmarker = null;

  let creatingLandmarker = null;

  let ringImage = null;

  let cameraStream = null;

  /*
   * "idle" | "camera" | "result"
   */
  let phase = "idle";

  let captureCanvas = null;
  let captureCtx = null;

  let busy = false;


  /*
   * Auto placement from hand detection.
   * All values in captured-photo pixels.
   */
  let ringBase = {
    x: 0,
    y: 0,
    width: 0,
    angle: 0
  };


  /*
   * Customer adjustments on top of the base.
   */
  let ringAdjust = {
    dx: 0,
    dy: 0,
    scale: 1,
    rotation: 0
  };


  /*
   * Active pointers for drag / pinch.
   */
  const pointers = new Map();

  let gestureStart = null;


  /* =========================================================
     START
     ========================================================= */

  function init() {

    openButton =
      document.getElementById("vto-open");

    modal =
      document.getElementById("vto-modal");

    closeButton =
      document.getElementById("vto-close");

    overlay =
      document.getElementById("vto-overlay");


    stage =
      document.getElementById("vto-stage");

    video =
      document.getElementById("vto-video");

    canvas =
      document.getElementById("vto-canvas");

    if (canvas) {
      ctx = canvas.getContext("2d");
    }


    hint =
      document.getElementById("vto-hint");


    cameraButton =
      document.getElementById("vto-camera");

    captureButton =
      document.getElementById("vto-capture");

    retakeButton =
      document.getElementById("vto-retake");

    cancelButton =
      document.getElementById("vto-cancel-camera");


    adjustPanel =
      document.getElementById("vto-adjust");

    sizeSlider =
      document.getElementById("vto-size");

    rotateSlider =
      document.getElementById("vto-rotate");

    resetButton =
      document.getElementById("vto-reset");


    status =
      document.getElementById("vto-status");

    loading =
      document.getElementById("vto-loading");

    loadingText =
      document.getElementById("vto-loading-text");

    stageMessage =
      document.getElementById("vto-stage-message");


    if (!openButton || !modal) {

      console.error(
        "Virtual Try On markup not found"
      );

      return;

    }

    /*
     * Move modal to <body> so the gallery's
     * overflow / transform / z-index cannot
     * clip or overlap it.
     */
    if (modal.parentElement !== document.body) {

      document.body.appendChild(modal);

    }
    captureCanvas =
      document.createElement("canvas");

    captureCtx =
      captureCanvas.getContext("2d");


    loadRingImage();

    setupModal();

    setupButtons();

    setupRingInteraction();


    console.log("Virtual Try On initialized");

  }


  /* =========================================================
     RING IMAGE
     ========================================================= */

  function loadRingImage() {

    const ringUrl =
      window.VTO_CONFIG &&
      window.VTO_CONFIG.ringImage;


    if (!ringUrl) {

      console.error("Ring image URL not found");

      return;

    }


    ringImage = new Image();

    ringImage.crossOrigin = "anonymous";


    ringImage.onload = function () {

      /*
       * If the photo is already on screen,
       * repaint with the loaded ring.
       */
      if (phase === "result") {
        render();
      }

    };


    ringImage.onerror = function () {

      console.error(
        "Ring image failed to load",
        ringUrl
      );

    };


    ringImage.src = ringUrl;

  }


  /* =========================================================
     MODAL
     ========================================================= */

  function setupModal() {

    openButton.addEventListener(
      "click",
      function (event) {

        event.preventDefault();

        event.stopPropagation();

        openModal();

      }
    );


    if (closeButton) {

      closeButton.addEventListener(
        "click",
        function (event) {

          event.preventDefault();

          closeModal();

        }
      );

    }


    if (overlay) {

      overlay.addEventListener(
        "click",
        closeModal
      );

    }


    document.addEventListener(
      "keydown",
      function (event) {

        if (
          event.key === "Escape" &&
          modal &&
          !modal.hidden
        ) {

          closeModal();

        }

      }
    );

  }


  function openModal() {

    modal.hidden = false;

    modal.setAttribute("aria-hidden", "false");

    modal.classList.add("is-open");

    document.body.style.overflow = "hidden";


    setPhase("idle");


    setStatus(
      "Tap \u201CUse Camera\u201D to start."
    );

  }


  function closeModal() {

    stopCamera();

    modal.classList.remove("is-open");

    modal.hidden = true;

    modal.setAttribute("aria-hidden", "true");

    document.body.style.overflow = "";


    phase = "idle";

  }


  /* =========================================================
     PHASE / UI

     idle   -> only "Use Camera"
     camera -> live preview + "Take Picture"
     result -> photo + adjustable ring + "Retake"
     ========================================================= */

  function setPhase(next) {

    phase = next;


    const isIdle = next === "idle";

    const isCamera = next === "camera";

    const isResult = next === "result";


    if (stageMessage) {

      stageMessage.style.display =
        isIdle ? "flex" : "none";

    }


    if (video) {
      video.hidden = !isCamera;
    }


    if (canvas) {

      canvas.hidden = !isResult;

      if (!isResult) {
        clearCanvas();
      }

    }


    if (cameraButton) {
      cameraButton.hidden = !isIdle;
    }


    if (captureButton) {
      captureButton.hidden = !isCamera;
    }


    if (retakeButton) {
      retakeButton.hidden = !isResult;
    }


    if (cancelButton) {
      cancelButton.hidden = !isCamera;
    }


    if (adjustPanel) {
      adjustPanel.hidden = !isResult;
    }


    if (hint) {

      if (isCamera) {

        hint.hidden = false;

        hint.textContent =
          "Hold your hand steady in the frame";

      } else if (isResult) {

        hint.hidden = false;

        hint.textContent =
          "Drag the ring \u00B7 pinch to resize \u00B7 twist to rotate";

      } else {

        hint.hidden = true;

      }

    }


    if (!isCamera) {
      hideLoading();
    }

  }


  /* =========================================================
     BUTTONS
     ========================================================= */

  function setupButtons() {

    if (cameraButton) {

      cameraButton.addEventListener(
        "click",
        startCamera
      );

    }


    if (captureButton) {

      captureButton.addEventListener(
        "click",
        capturePhoto
      );

    }


    if (retakeButton) {

      retakeButton.addEventListener(
        "click",
        startCamera
      );

    }


    if (cancelButton) {

      cancelButton.addEventListener(
        "click",
        function () {

          stopCamera();

          setPhase("idle");

          setStatus(
            "Tap \u201CUse Camera\u201D to start."
          );

        }
      );

    }


    if (sizeSlider) {

      sizeSlider.addEventListener(
        "input",
        function () {

          ringAdjust.scale =
            Number(sizeSlider.value) / 100;

          render();

        }
      );

    }


    if (rotateSlider) {

      rotateSlider.addEventListener(
        "input",
        function () {

          ringAdjust.rotation =
            (Number(rotateSlider.value) * Math.PI) / 180;

          render();

        }
      );

    }


    if (resetButton) {

      resetButton.addEventListener(
        "click",
        function () {

          resetAdjust();

          render();

          setStatus(
            "Ring reset to the detected position."
          );

        }
      );

    }

  }


  function resetAdjust() {

    ringAdjust.dx = 0;

    ringAdjust.dy = 0;

    ringAdjust.scale = 1;

    ringAdjust.rotation = 0;


    syncSliders();

  }


  function syncSliders() {

    if (sizeSlider) {

      sizeSlider.value =
        String(Math.round(ringAdjust.scale * 100));

    }


    if (rotateSlider) {

      let degrees =
        (ringAdjust.rotation * 180) / Math.PI;


      /*
       * Keep inside the slider range.
       */
      while (degrees > 180) {
        degrees -= 360;
      }

      while (degrees < -180) {
        degrees += 360;
      }


      rotateSlider.value =
        String(Math.round(degrees));

    }

  }


  /* =========================================================
     STATUS / LOADING
     ========================================================= */

  function setStatus(message) {

    if (status) {
      status.textContent = message;
    }

  }


  function showLoading(message) {

    if (!loading) {
      return;
    }


    loading.hidden = false;


    if (loadingText) {

      loadingText.textContent =
        message || "Loading...";

    }

  }


  function hideLoading() {

    if (loading) {
      loading.hidden = true;
    }

  }


  /* =========================================================
     MEDIAPIPE READY
     ========================================================= */

  function waitForMediaPipe() {

    if (window.MediaPipeVision) {

      return Promise.resolve(
        window.MediaPipeVision
      );

    }


    return new Promise(
      function (resolve, reject) {

        let finished = false;


        function onReady() {

          if (finished) {
            return;
          }


          if (window.MediaPipeVision) {

            finished = true;

            resolve(window.MediaPipeVision);

          }

        }


        window.addEventListener(
          "vto-mediapipe-ready",
          onReady,
          { once: true }
        );


        setTimeout(
          function () {

            if (finished) {
              return;
            }


            finished = true;


            if (window.MediaPipeVision) {

              resolve(window.MediaPipeVision);

            } else {

              reject(
                new Error(
                  "MediaPipe Tasks Vision library did not load."
                )
              );

            }

          },
          15000
        );

      }
    );

  }


  /* =========================================================
     CREATE HAND LANDMARKER

     IMAGE mode only.
     ========================================================= */

  async function createHandLandmarker() {

    if (handLandmarker) {
      return handLandmarker;
    }


    if (creatingLandmarker) {
      return creatingLandmarker;
    }


    creatingLandmarker =
      (async function () {

        const mp = await waitForMediaPipe();


        if (
          !mp.FilesetResolver ||
          !mp.HandLandmarker
        ) {

          throw new Error(
            "HandLandmarker API is unavailable."
          );

        }


        const vision =
          await mp.FilesetResolver.forVisionTasks(
            CONFIG.wasm
          );


        const options = {

          baseOptions: {
            modelAssetPath: CONFIG.model,
            delegate: "GPU"
          },

          runningMode: "IMAGE",

          numHands: 1,

          minHandDetectionConfidence: 0.4,

          minHandPresenceConfidence: 0.4,

          minTrackingConfidence: 0.4

        };


        let landmarker = null;


        try {

          landmarker =
            await mp.HandLandmarker.createFromOptions(
              vision,
              options
            );

        } catch (gpuError) {

          console.warn(
            "GPU failed. Trying CPU...",
            gpuError
          );


          options.baseOptions.delegate = "CPU";


          landmarker =
            await mp.HandLandmarker.createFromOptions(
              vision,
              options
            );

        }


        handLandmarker = landmarker;

        return handLandmarker;

      })();


    try {

      return await creatingLandmarker;

    } finally {

      creatingLandmarker = null;

    }

  }


  /* =========================================================
     CAMERA
     ========================================================= */

  async function startCamera() {

    if (busy) {
      return;
    }


    busy = true;


    try {

      stopCamera();


      setPhase("camera");


      showLoading("Opening camera...");


      setStatus("Starting camera...");


      cameraStream =
        await getBackCameraStream();


      video.srcObject = cameraStream;


      await video.play();


      await waitForVideoSize();


      hideLoading();


      setStatus(
        "Frame your hand, then tap Take Picture."
      );


      /*
       * Warm up the model so capture
       * feels instant.
       */
      createHandLandmarker()
        .catch(function (error) {

          console.warn(
            "Model preload failed:",
            error
          );

        });

    } catch (error) {

      console.error("Camera error:", error);


      hideLoading();

      stopCamera();

      setPhase("idle");

      setStatus(getFriendlyError(error));

    } finally {

      busy = false;

    }

  }


  async function getBackCameraStream() {

    const sizes = {

      width: { ideal: 1920 },

      height: { ideal: 1080 }

    };


    const attempts = [

      {
        video: Object.assign(
          { facingMode: { exact: "environment" } },
          sizes
        ),
        audio: false
      },

      {
        video: Object.assign(
          { facingMode: "environment" },
          sizes
        ),
        audio: false
      },

      {
        video: true,
        audio: false
      }

    ];


    let lastError = null;


    for (let i = 0; i < attempts.length; i++) {

      try {

        return await navigator.mediaDevices.getUserMedia(
          attempts[i]
        );

      } catch (error) {

        lastError = error;


        if (
          error &&
          (error.name === "NotAllowedError" ||
            error.name === "SecurityError")
        ) {

          throw error;

        }

      }

    }


    throw lastError || new Error("NotFoundError");

  }


  function waitForVideoSize() {

    return new Promise(
      function (resolve) {

        if (video.videoWidth) {

          resolve();

          return;

        }


        let done = false;


        function ready() {

          if (done) {
            return;
          }

          done = true;

          resolve();

        }


        video.addEventListener(
          "loadedmetadata",
          ready,
          { once: true }
        );


        setTimeout(ready, 2500);

      }
    );

  }


  function stopCamera() {

    if (cameraStream) {

      cameraStream
        .getTracks()
        .forEach(function (track) {

          track.stop();

        });


      cameraStream = null;

    }


    if (video) {

      try {
        video.pause();
      } catch (e) {
        /* ignore */
      }

      video.srcObject = null;

    }

  }


  /* =========================================================
     CAPTURE
     ========================================================= */

  async function capturePhoto() {

    if (busy || phase !== "camera") {
      return;
    }


    if (!video || !video.videoWidth) {

      setStatus(
        "Camera is not ready yet. Please wait a moment."
      );

      return;

    }


    busy = true;


    try {

      showLoading("Processing your photo...");


      grabVisibleFrame();


      stopCamera();


      let result = null;


      try {

        await createHandLandmarker();

        result =
          handLandmarker.detect(captureCanvas);

      } catch (detectError) {

        console.warn(
          "Hand detection unavailable:",
          detectError
        );

      }


      setPhase("result");


      const detected =
        applyAutoPlacement(result);


      resetAdjust();

      render();

      hideLoading();


      if (detected) {

        setStatus(
          "Ring placed automatically. Drag it to any finger, pinch to resize."
        );

      } else {

        setStatus(
          "Hand not detected. Drag the ring onto the finger you want and resize it."
        );

      }

    } catch (error) {

      console.error("Capture error:", error);


      hideLoading();

      setPhase("result");

      applyAutoPlacement(null);

      resetAdjust();

      render();

      setStatus(getFriendlyError(error));

    } finally {

      busy = false;

    }

  }


  /* =========================================================
     GRAB VISIBLE FRAME

     The video fills the stage with
     object-fit: cover, so part of the frame
     is cropped on screen. We capture the
     same crop so the photo matches the
     preview exactly.
     ========================================================= */

  function grabVisibleFrame() {

    const videoWidth = video.videoWidth;

    const videoHeight = video.videoHeight;


    const box =
      stage
        ? stage.getBoundingClientRect()
        : { width: videoWidth, height: videoHeight };


    const boxWidth = box.width || videoWidth;

    const boxHeight = box.height || videoHeight;


    const scale =
      Math.max(
        boxWidth / videoWidth,
        boxHeight / videoHeight
      );


    const sourceWidth =
      Math.min(videoWidth, boxWidth / scale);

    const sourceHeight =
      Math.min(videoHeight, boxHeight / scale);


    const sourceX =
      (videoWidth - sourceWidth) / 2;

    const sourceY =
      (videoHeight - sourceHeight) / 2;


    let outWidth = sourceWidth;

    let outHeight = sourceHeight;


    const longest =
      Math.max(outWidth, outHeight);


    if (longest > CONFIG.maxCaptureSize) {

      const shrink =
        CONFIG.maxCaptureSize / longest;

      outWidth *= shrink;

      outHeight *= shrink;

    }


    captureCanvas.width =
      Math.max(1, Math.round(outWidth));

    captureCanvas.height =
      Math.max(1, Math.round(outHeight));


    captureCtx.clearRect(
      0,
      0,
      captureCanvas.width,
      captureCanvas.height
    );


    if (CONFIG.mirrorCamera) {

      captureCtx.save();

      captureCtx.translate(
        captureCanvas.width,
        0
      );

      captureCtx.scale(-1, 1);

    }


    captureCtx.drawImage(
      video,

      sourceX,
      sourceY,
      sourceWidth,
      sourceHeight,

      0,
      0,
      captureCanvas.width,
      captureCanvas.height
    );


    if (CONFIG.mirrorCamera) {
      captureCtx.restore();
    }


    /*
     * Match the visible canvas to the capture.
     */
    if (canvas) {

      canvas.width = captureCanvas.width;

      canvas.height = captureCanvas.height;

    }

  }


  /* =========================================================
     AUTO PLACEMENT

     Sets the starting position from the
     detected hand. Returns false if there
     is nothing to detect, and falls back
     to the centre of the photo.
     ========================================================= */

  function applyAutoPlacement(result) {

    const centreFallback = function () {

      ringBase.x = captureCanvas.width / 2;

      ringBase.y = captureCanvas.height / 2;

      ringBase.width =
        captureCanvas.width *
        CONFIG.fallbackRingWidth;

      ringBase.angle = 0;

    };


    if (
      !result ||
      !result.landmarks ||
      !result.landmarks.length
    ) {

      centreFallback();

      return false;

    }


    const landmarks = result.landmarks[0];

    const mcp = landmarks[CONFIG.defaultFinger[0]];

    const pip = landmarks[CONFIG.defaultFinger[1]];


    if (!mcp || !pip) {

      centreFallback();

      return false;

    }


    const pMcp = landmarkToPixel(mcp);

    const pPip = landmarkToPixel(pip);


    const fingerLength = distance(pMcp, pPip);


    if (fingerLength < 5) {

      centreFallback();

      return false;

    }


    const centre =
      interpolatePoint(
        pMcp,
        pPip,
        CONFIG.ringCenterAlongFinger
      );


    ringBase.x = centre.x;

    ringBase.y = centre.y;


    ringBase.width =
      fingerLength * CONFIG.ringSizeMultiplier;


    ringBase.angle =
      Math.atan2(
        pPip.y - pMcp.y,
        pPip.x - pMcp.x
      ) +
      Math.PI / 2 +
      CONFIG.ringRotationOffset;


    return true;

  }


  /* =========================================================
     RENDER

     Repaints the photo and the ring using
     the current base + adjustments.
     ========================================================= */

  function render() {

    if (
      !ctx ||
      !canvas ||
      !captureCanvas ||
      !captureCanvas.width
    ) {

      return;

    }


    ctx.clearRect(
      0,
      0,
      canvas.width,
      canvas.height
    );


    ctx.drawImage(captureCanvas, 0, 0);


    if (
      !ringImage ||
      !ringImage.complete ||
      !ringImage.naturalWidth
    ) {

      return;

    }


    const width =
      ringBase.width * ringAdjust.scale;


    const aspect =
      ringImage.naturalHeight /
      ringImage.naturalWidth;


    const height = width * aspect;


    const x = ringBase.x + ringAdjust.dx;

    const y = ringBase.y + ringAdjust.dy;


    const angle =
      ringBase.angle + ringAdjust.rotation;


    ctx.save();

    ctx.translate(x, y);

    ctx.rotate(angle);


    ctx.drawImage(
      ringImage,

      -width / 2,
      -height / 2,

      width,
      height
    );


    ctx.restore();

  }


  /* =========================================================
     RING INTERACTION

     One finger  -> move the ring
     Two fingers -> pinch to resize, twist to rotate
     Mouse wheel -> resize
     ========================================================= */

  function setupRingInteraction() {

    if (!canvas) {
      return;
    }


    canvas.addEventListener(
      "pointerdown",
      onPointerDown
    );

    canvas.addEventListener(
      "pointermove",
      onPointerMove
    );

    canvas.addEventListener(
      "pointerup",
      onPointerUp
    );

    canvas.addEventListener(
      "pointercancel",
      onPointerUp
    );

    canvas.addEventListener(
      "pointerleave",
      onPointerUp
    );


    canvas.addEventListener(
      "wheel",
      onWheel,
      { passive: false }
    );

  }


  function onPointerDown(event) {

    if (phase !== "result") {
      return;
    }


    event.preventDefault();


    canvas.setPointerCapture(event.pointerId);


    pointers.set(
      event.pointerId,
      clientToCanvas(event.clientX, event.clientY)
    );


    beginGesture();

  }


  function onPointerMove(event) {

    if (
      phase !== "result" ||
      !pointers.has(event.pointerId)
    ) {

      return;

    }


    event.preventDefault();


    pointers.set(
      event.pointerId,
      clientToCanvas(event.clientX, event.clientY)
    );


    updateGesture();

  }


  function onPointerUp(event) {

    if (!pointers.has(event.pointerId)) {
      return;
    }


    pointers.delete(event.pointerId);


    try {

      canvas.releasePointerCapture(event.pointerId);

    } catch (e) {
      /* ignore */
    }


    /*
     * Re-base the gesture so the remaining
     * finger does not jump.
     */
    beginGesture();

  }


  function beginGesture() {

    const points =
      Array.from(pointers.values());


    if (!points.length) {

      gestureStart = null;

      return;

    }


    gestureStart = {

      points: points,

      centre: averagePoint(points),

      distance:
        points.length > 1
          ? distance(points[0], points[1])
          : 0,

      angle:
        points.length > 1
          ? Math.atan2(
              points[1].y - points[0].y,
              points[1].x - points[0].x
            )
          : 0,

      adjust: {
        dx: ringAdjust.dx,
        dy: ringAdjust.dy,
        scale: ringAdjust.scale,
        rotation: ringAdjust.rotation
      }

    };

  }


  function updateGesture() {

    if (!gestureStart) {
      return;
    }


    const points =
      Array.from(pointers.values());


    if (!points.length) {
      return;
    }


    const centre = averagePoint(points);


    /*
     * MOVE
     */
    ringAdjust.dx =
      gestureStart.adjust.dx +
      (centre.x - gestureStart.centre.x);

    ringAdjust.dy =
      gestureStart.adjust.dy +
      (centre.y - gestureStart.centre.y);


    /*
     * PINCH + TWIST
     */
    if (
      points.length > 1 &&
      gestureStart.distance > 0
    ) {

      const currentDistance =
        distance(points[0], points[1]);


      setScale(
        gestureStart.adjust.scale *
          (currentDistance / gestureStart.distance)
      );


      const currentAngle =
        Math.atan2(
          points[1].y - points[0].y,
          points[1].x - points[0].x
        );


      ringAdjust.rotation =
        gestureStart.adjust.rotation +
        (currentAngle - gestureStart.angle);


      syncSliders();

    }


    render();

  }


  function onWheel(event) {

    if (phase !== "result") {
      return;
    }


    event.preventDefault();


    const step =
      event.deltaY < 0 ? 1.06 : 0.94;


    setScale(ringAdjust.scale * step);

    syncSliders();

    render();

  }


  function setScale(value) {

    ringAdjust.scale =
      Math.min(
        CONFIG.maxScale,
        Math.max(CONFIG.minScale, value)
      );

  }


  /* =========================================================
     CLIENT -> CANVAS COORDINATES

     The canvas is displayed with
     object-fit: cover, so screen pixels
     must be mapped back to photo pixels.
     ========================================================= */

  function clientToCanvas(clientX, clientY) {

    const rect = canvas.getBoundingClientRect();


    const scale =
      Math.max(
        rect.width / canvas.width,
        rect.height / canvas.height
      );


    const displayedWidth = canvas.width * scale;

    const displayedHeight = canvas.height * scale;


    const offsetX =
      rect.left + (rect.width - displayedWidth) / 2;

    const offsetY =
      rect.top + (rect.height - displayedHeight) / 2;


    return {

      x: (clientX - offsetX) / scale,

      y: (clientY - offsetY) / scale

    };

  }


  /* =========================================================
     HELPERS
     ========================================================= */

  function landmarkToPixel(landmark) {

    return {

      x: landmark.x * captureCanvas.width,

      y: landmark.y * captureCanvas.height

    };

  }


  function interpolatePoint(a, b, amount) {

    return {

      x: a.x + (b.x - a.x) * amount,

      y: a.y + (b.y - a.y) * amount

    };

  }


  function averagePoint(points) {

    let x = 0;

    let y = 0;


    for (let i = 0; i < points.length; i++) {

      x += points[i].x;

      y += points[i].y;

    }


    return {

      x: x / points.length,

      y: y / points.length

    };

  }


  function distance(a, b) {

    const dx = b.x - a.x;

    const dy = b.y - a.y;


    return Math.sqrt(dx * dx + dy * dy);

  }


  function clearCanvas() {

    if (!ctx || !canvas) {
      return;
    }


    ctx.clearRect(
      0,
      0,
      canvas.width,
      canvas.height
    );

  }


  /* =========================================================
     FRIENDLY ERROR
     ========================================================= */

  function getFriendlyError(error) {

    const name = (error && error.name) || "";

    const message =
      error && error.message
        ? error.message
        : String(error);


    console.error("VTO ERROR:", name, message);


    if (
      name === "NotAllowedError" ||
      name === "SecurityError" ||
      message.includes("Permission") ||
      message.includes("NotAllowed")
    ) {

      return "Camera permission was denied. Please allow camera access and try again.";

    }


    if (
      name === "NotFoundError" ||
      message.includes("NotFoundError")
    ) {

      return "No camera was found on this device.";

    }


    if (
      name === "NotReadableError" ||
      name === "TrackStartError"
    ) {

      return "Your camera is being used by another app. Close it and try again.";

    }


    return "Something went wrong. Please retake the photo.";

  }


  /* =========================================================
     INITIALIZE
     ========================================================= */

  if (document.readyState === "loading") {

    document.addEventListener(
      "DOMContentLoaded",
      init
    );

  } else {

    init();

  }

})();
